import angular from 'angular';
import ngMessages from 'angular-messages';
import {DashboardComponent} from './dashboard.component'
import {AppHeaderComponent} from "./appHeader.component";
import {AppPromoteComponent} from "./appPromote/appPromote.component";
import {ProfileHeaderComponent} from "./profileHeader.component";
import {SchedulePdfComponent} from "./schedulePdf.component";
import {SchedulePickerComponent} from './schedulePicker.component'
import {TabBarComponent} from "./tabBar.component";
import {MedCalendarsComponent} from "./medCalendars.component";
import {LoadingAnimationComponent} from "./loadingAnimation.component";
import {ProfileIconComponent} from "./profileIcon.component";
import {ConnectionCompletePopupComponent} from "./connectionCompletePopup.component";
import {FiltersModule} from "../../filters/app.filters.module";
import {SmallScreenPopupComponent} from "./smallScreenPopup.component";

export const DashboardModule = angular
    .module('mmsApp.pages.dashboard', [
        ngMessages,
        FiltersModule
    ])
    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('pages.dashboard', {
                data: {},
                url: '/dashboard',
                params: {
                    isFromPatientConnect: false,
                    preselectedPatient: null,
                    expired: false
                },
                component: DashboardComponent.name,
                resolve: {}
            })
    })
    .component(DashboardComponent.name, DashboardComponent.component)
    .component(AppHeaderComponent.name, AppHeaderComponent.component)
    .component(AppPromoteComponent.name, AppPromoteComponent.component)
    .component(ProfileHeaderComponent.name, ProfileHeaderComponent.component)
    .component(SchedulePdfComponent.name, SchedulePdfComponent.component)
    .component(SchedulePickerComponent.name, SchedulePickerComponent.component)
    .component(TabBarComponent.name, TabBarComponent.component)
    .component(MedCalendarsComponent.name, MedCalendarsComponent.component)
    .component(LoadingAnimationComponent.name, LoadingAnimationComponent.component)
    .component(ProfileIconComponent.name, ProfileIconComponent.component)
    .component(ConnectionCompletePopupComponent.name, ConnectionCompletePopupComponent.component)
    .component(SmallScreenPopupComponent.name, SmallScreenPopupComponent.component)
    .name
;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.module.js